import { useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';

import { resolvedThemeVar } from 'core/state/themeState';

import { IEmailFrameDarkTheme } from './richMailModel';

const readVar = (style: CSSStyleDeclaration, name: string): string =>
  style.getPropertyValue(name).trim();

/**
 * ТЗ 0122 — тема для фрейма письма. Светлая — `null` (документ фрейма
 * прежний); тёмная — цвета `--c-*`, прочитанные в документе ERP (фрейм
 * своих переменных не видит). Смена темы на лету меняет значение, фрейм
 * перерисовывается.
 */
export const useEmailFrameTheme = (): IEmailFrameDarkTheme | null => {
  const theme = useReactiveVar(resolvedThemeVar);
  return useMemo(() => {
    if (theme !== 'dark' || typeof document === 'undefined') return null;
    // `apply()` ставит `data-theme` раньше, чем меняет переменную, —
    // значения уже тёмные.
    const style = getComputedStyle(document.documentElement);
    return {
      text: readVar(style, '--c-text'),
      textMuted: readVar(style, '--c-text-2'),
      link: readVar(style, '--c-accent-text'),
      border: readVar(style, '--c-border-strong'),
    };
  }, [theme]);
};
